module.exports = __webpack_public_path__ + "img/yjk02.65095ed8.png";